<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/boxes/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Barcode</th>
                <th class="text-center">Produkte</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="box in boxes" :key="box.id">
                <td>{{ box.name }}</td>
                <td>
                  {{ box.barcode }}
                  <a :href="`${api}/boxes/${box.id}/custom_label/barcode?barcode_size=${barCodeSize ? barCodeSize : '38x11'}`"
                    target="_blank" class="btn btn-warning btn-link btn-xs"
                    v-tooltip.top-center="'Barcode drucken'"
                  >
                    <i class="fas fa-barcode"></i>
                  </a>
                </td>
                <td class="text-center">
                  <a v-tooltip.top-center="'Produkte'" class="btn btn-info btn-link btn-xs"
                   @click="openProducts(box)"
                  >
                    <i class="fas fa-boxes" aria-hidden="true"></i>
                  </a>
                </td>
                <td class="text-right">
                  <div class="td-actions">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                       @click="$router.push(`/boxes/${box.id}/edit`)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                       @click="deleteBox(box)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
    <products-dialog
      :show="showProducts"
      :products="products"
      @close="showProducts = false"
    />
  </div>
</template>

<script>
import ProductsDialog from './products-dialog'
import api from 'src/api'

export default {
  components: { ProductsDialog },
  data () {
    return {
      api,
      boxes: [],
      products: [],
      showProducts: false,
      barCodeSize: process.env.VUE_APP_BARCODE_SIZE,
    }
  },
  methods: {
    async deleteBox (box) {
      if (confirm(`Box ${box.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/boxes/${box.id}`).then(({ data }) => {
          this.$notify({
            message: `Box ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.boxes.findIndex(({ id }) => data.id === id)
          this.boxes.splice(index, 1)
        })
      }
    },
    openProducts (box) {
      this.products = box.products
      this.showProducts = true
    }
  },
  created () {
    this.$http.get('/boxes').then(({ data }) => { this.boxes = data })
  }
}
</script>
